export interface IModelLoginRequest {
  clientId: string;
  username: string;
  password: string;
  remember_me: boolean;
  expires_in: string;
}

export interface IModelLoginResponse {
  credential: IModelLoginCredentialResponse;
}
export interface IModelLoginCredentialResponse {
  scopes: IModelLoginCredentialScopesResponse[];
  accessToken: string;
  refreshToken: string;
}
export interface IModelLoginCredentialScopesResponse {
  scope: string;
  hostName: string | null;
  urlPath: string | null;
}


export class ModelUserAuth {
  credential: ModelUserAuthCredential

  constructor(props = {} as IModelLoginResponse) {
    props = props ?? {}
    this.credential = new ModelUserAuthCredential(props.credential || {});
  }
}

export class ModelUserAuthCredential {
  scopeList: ModelUserAuthCredentialScopes[];
  accessToken: string;
  refreshToken: string;

  constructor(props = {} as IModelLoginCredentialResponse) {
    props = props ?? {};
    this.scopeList = (props.scopes || []).map(e => new ModelUserAuthCredentialScopes(e))
    this.accessToken = props.accessToken;
    this.refreshToken = props.refreshToken;
  }
}
export class ModelUserAuthCredentialScopes {
  scope: string;
  hostName: string | null;
  urlPath: string | null;

  constructor(props = {} as IModelLoginCredentialScopesResponse) {
    props = props ?? {}
    this.scope = props.scope;
    this.hostName = props.hostName;
    this.urlPath = props.urlPath;
  }
}